<div class="header">
  <h2>{{ "pages.analytics.semantics.title" | translate }}</h2>
  <div class="filters">
    <app-tutor-filter-control
      [analyticsPage]="'semantics'"
    ></app-tutor-filter-control>
    <app-date-range-control
      [analyticsPage]="'semantics'"
    ></app-date-range-control>
  </div>
</div>

<div class="grid">
  <nb-card class="card col-span-3">
    <nb-card-header>
      <app-chart-header
        [title]="'charts.titles.semanticsTimeSeriesTopic' | translate"
        [infoText]="'charts.descriptions.semanticsTimeSeriesTopic' | translate"
        [isDemo]="analyticsService.isDemo('semanticsTimeSeriesTopic')"
      ></app-chart-header>
    </nb-card-header>
    <nb-card-body>
      <app-line-semantics-time-series-topic></app-line-semantics-time-series-topic>
    </nb-card-body>
  </nb-card>

  <nb-card class="card col-span-3">
    <nb-card-header>
      <app-chart-header
        [title]="'charts.titles.semanticsDonutTopics' | translate"
        [infoText]="'charts.descriptions.semanticsDonutTopics' | translate"
        [isDemo]="analyticsService.isDemo('semanticsDonutTopics')"
      ></app-chart-header>
    </nb-card-header>
    <nb-card-body>
      <app-semantics-donut-topic></app-semantics-donut-topic>
    </nb-card-body>
  </nb-card>

  <nb-card class="card full-width">
    <nb-card-header>
      <app-chart-header
        [title]="'charts.titles.semanticsTopics' | translate"
        [infoText]="'charts.descriptions.semanticsTopics' | translate"
        [isDemo]="analyticsService.isDemo('semanticsTopicsTree')"
      ></app-chart-header>
    </nb-card-header>
    <nb-card-body>
      <app-sankey-semantics-topics></app-sankey-semantics-topics>
    </nb-card-body>
  </nb-card>

  <nb-card class="card col-span-3">
    <nb-card-header>
      <app-chart-header
        [title]="'charts.titles.semanticsRankingTopCanonicals' | translate"
        [infoText]="
          'charts.descriptions.semanticsRankingTopCanonicals' | translate
        "
        [isDemo]="analyticsService.isDemo('semanticsRankingTopicsCanonicals')"
      ></app-chart-header>
    </nb-card-header>
    <nb-card-body>
      <app-semantics-ranking-top-canonicals></app-semantics-ranking-top-canonicals>
    </nb-card-body>
  </nb-card>

  <nb-card class="card col-span-3 max-height">
    <nb-card-header>
      <app-chart-header
        [title]="'charts.titles.semanticsRankingTopTopic' | translate"
        [infoText]="'charts.descriptions.semanticsRankingTopTopic' | translate"
        [isDemo]="analyticsService.isDemo('semanticsRankingTopicsCanonicals')"
      ></app-chart-header>
    </nb-card-header>
    <nb-card-body>
      <app-semantics-ranking-top-topics></app-semantics-ranking-top-topics>
    </nb-card-body>
  </nb-card>

  <nb-card class="card col-span-3 max-height">
    <nb-card-header>
      <app-chart-header
        [title]="'charts.titles.semanticsTimeSeriesBloom' | translate"
        [infoText]="'charts.descriptions.semanticsTimeSeriesBloom' | translate"
        [isDemo]="analyticsService.isDemo('semanticsTimeSeriesBloom')"
      ></app-chart-header>
    </nb-card-header>
    <nb-card-body>
      <app-line-semantics-time-series-bloom></app-line-semantics-time-series-bloom>
    </nb-card-body>
  </nb-card>

  <nb-card class="card col-span-3">
    <nb-card-header>
      <app-chart-header
        [title]="'charts.titles.semanticsDonutBloom' | translate"
        [infoText]="'charts.descriptions.semanticsDonutBloom' | translate"
        [isDemo]="analyticsService.isDemo('semanticsDonutBloom')"
      ></app-chart-header>
    </nb-card-header>
    <nb-card-body>
      <app-semantics-donut-bloom></app-semantics-donut-bloom>
    </nb-card-body>
  </nb-card>

  <nb-card class="card col-span-3">
    <nb-card-header>
      <app-chart-header
        [title]="'charts.titles.semanticsTimeSeriesIntent' | translate"
        [infoText]="'charts.descriptions.semanticsTimeSeriesIntent' | translate"
        [isDemo]="analyticsService.isDemo('semanticsTimeSeriesIntent')"
      ></app-chart-header>
    </nb-card-header>
    <nb-card-body>
      <app-line-semantics-time-series-intent></app-line-semantics-time-series-intent>
    </nb-card-body>
  </nb-card>

  <nb-card class="card col-span-3">
    <nb-card-header>
      <app-chart-header
        [title]="'charts.titles.semanticsDonutIntent' | translate"
        [infoText]="'charts.descriptions.semanticsDonutIntent' | translate"
        [isDemo]="analyticsService.isDemo('semanticsDonutIntent')"
      ></app-chart-header>
    </nb-card-header>
    <nb-card-body>
      <app-semantics-donut-intent></app-semantics-donut-intent>
    </nb-card-body>
  </nb-card>
</div>
